import Marquee from "react-fast-marquee";
import {
  selectMainState,
  setViewRadioPlayer,
} from "../../../../store/slices/main";
import { useAppDispatch, useAppSelector } from "../../../../hooks/redux-hooks";
import EfirControl from "../../../common/player/radioPlayer/fullScreenRadioPlayer/components/EfirControl";

const MobileHeaderPlayer = () => {
  const dispatch = useAppDispatch();
  const {
    radioPlayer: { metadata, player, radio, playForTrack, preRollPlayed },
    audioPlayer,
  } = useAppSelector(selectMainState);

  return (
    <>
      {player && (
        <div className="w-full flex items-start h-[3.5rem] rounded-md">
          <div className="w-full">
            <div className="pt-3 w-full h-full flex justify-center items-center">
              <EfirControl
                isMetadataActive={!!metadata}
                isRadioActice={radio}
              />
            </div>
            <div
              className="overflow-hidden text-ellipsis line-clamp-1 w-full"
              onClick={() => {
                audioPlayer.overTop
                  ? dispatch(setViewRadioPlayer(true))
                  : dispatch(setViewRadioPlayer(false));
              }}
            >
              <h4
                className={`max-w-full text-base font-bold text-center transition-transform duration-500`}
              >
                {radio && !playForTrack ? (
                  <span>
                    {metadata.length > 30 ? (
                      <Marquee
                        pauseOnHover={true}
                        speed={20}
                        style={{ width: "100%" }}
                      >
                        <span className="pr-5">{metadata}</span>
                        <span className="pr-5">{metadata}</span>
                        <span className="pr-5">{metadata}</span>
                      </Marquee>
                    ) : (
                      <>{metadata}</>
                    )}
                  </span>
                ) : preRollPlayed ? (
                  <span>РЕКЛАМА</span>
                ) : (
                  <span>РАДІО «СІЛЬПО»</span>
                )}
              </h4>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MobileHeaderPlayer;
